// Import from NPM
// -------------------------------------
import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

// Import Reducer Routes
// -------------------------------------
import { AuthenticationReducer } from "app/authentication/redux/Authentication.reducer.react";
import { DriveReducer } from "app/course/editor/redux/Drive.reducer.react";
import { LearnerManagerReducer } from "app/course/editor/redux/LearnerManager.reducer.react";
import { DeckAttemptReducer } from "app/deck/viewer/redux/DeckAttempt.reducer.react";
import { CoursesReducer } from "app/course/viewer/redux/Courses.reducer.react";
import { HelpDeskReducer } from "app/Help/redux/HelpDesk.reducer.react";
import { DeckEditorReducer } from "app/deck/editor/deckEditor/redux/DeckEditor.reducer.react";
import { CreatorConfigReducer } from "app/deck/editor/deckEditor/redux/CreatorConfig.reducer.react";
import { FeedReducer } from "app/social/redux/Feed.reducer.react";
import { BlogReducer } from "app/blog/redux/Blog.reducer.react";
import { UsersReducer } from "app/adminPanels/redux/Users.reducer.react";
import { AllCoursesReducer } from "app/adminPanels/redux/AllCourses.reducer.react";
import { AppConfigReducer } from "app/adminPanels/redux/AppConfig.reducer.react";
import { TicketsReducer } from "app/adminPanels/redux/Ticket.reducer.react";
import { CouponsReducer } from "app/authentication/redux/Coupons.reducer.react.js";

let RootReducer = combineReducers({
    auth: AuthenticationReducer,
    routing: routerReducer,
    courses: CoursesReducer,
    editingCourse: DriveReducer,
    deckAttempt: DeckAttemptReducer,
    enrolments: LearnerManagerReducer,
    helpDesk: HelpDeskReducer,
    config: CreatorConfigReducer,
    deck: DeckEditorReducer,
    feed: FeedReducer,
    blog: BlogReducer,
    users: UsersReducer,
    allCourses: AllCoursesReducer,
    appConfig: AppConfigReducer,
    tickets: TicketsReducer,
    coupons: CouponsReducer
});

export { RootReducer };